import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './d-edit-network-external-connections.js';
import { ResponsiveContainer } from 'src/library/elements/responsive-container.js';
import type { InfosecNetwork } from '../infosecNetwork';
import type { InfosecExternalConnection } from '../infosecExternalConnection';
import type { SelectDropdownOption } from '../../../../library/editors/elements/select-dropdown-option';

/**
 * Lists all networks with their external connections. Employees can only be added to a single network and are
 * not available if already connected.
 *
 */
@customElement('d-edit-networks-external-connections')
export class DEditNetworksExternalConnections extends ResponsiveContainer {
  static readonly styles = [
    css`
      :host {
        display: block;
      }
      table {
        position: relative;
        width: 100%;
        border-collapse: collapse;
        border-bottom: 1px solid var(--borderColorOnGray);
      }
      td {
        width: auto;
        vertical-align: top;
        border-top: 1px solid var(--borderColorOnGray);
        padding: 12px 0 8px 0;
      }
      td:first-child {
        text-align: left;
        padding-right: 20px;
        display: none;
      }
      :host(.width600) td:first-child {
        display: table-cell;
      }
      td:last-child {
        padding-bottom: 12px;
      }
      d-label {
        margin-bottom: 8px;
      }
      td:first-child d-label {
        padding-top: 4px;
      }
      td:last-child d-label {
        padding-top: 0;
      }
      :host(.width600) td:last-child d-label {
        display: none;
      }
      td > * {
        display: block;
      }
    `,
  ];

  /**
   * The list of networks.
   */
  @property({ type: Array })
  networks: InfosecNetwork[] = [];

  /**
   * The list of external connections. The complete list is passed down because employees may only be connected to a single network.
   */
  @property({ type: Array })
  externalConnections: InfosecExternalConnection[] = [];

  /**
   * The available employees.
   */
  @property({ type: Array })
  employees: { value: string; text: string }[] = [];

  /**
   * The available partners.
   */
  @property({ type: Array })
  partners: SelectDropdownOption[] = [];

  render() {
    return html`
      <table>
        ${this.networks.map((network) => {
          return html`
            <tr>
              <td>
                <d-label .label=${network.name}></d-label>
              </td>
              <td>
                <d-label .label=${network.name}></d-label>
                <div>
                  <d-edit-network-external-connections
                    .network=${network}
                    .externalConnections=${this.externalConnections}
                    .employees=${this.employees}
                    .partners=${this.partners}
                  ></d-edit-network-external-connections>
                </div>
              </td>
            </tr>
          `;
        })}
      </table>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-edit-networks-external-connections': DEditNetworksExternalConnections;
  }
}
